import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, WishlistPayload } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'customer/wishlist',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<WishlistPayload>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchWishlist (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().customer.fetchWishlist()
      const { data } = response || {}
      const { wishlist } = data || {}

      if (wishlist) {
        dispatch(success(wishlist))
      } else {
        dispatch(failure())
      }

      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
